import React from 'react'
import RenderPrintPdf from '../../../../components/Impressao/RenderPrintPdf'
import GuiaInternacaoPDF from '../../../../template/pdf/GuiaInternacao/GuiaInternacao'

export const renderPrintPdf = ({ guiaInternacao, pdfToPrint, onAfterPrint }) => (
  <RenderPrintPdf
    pdfDocument={<GuiaInternacaoPDF guiaInternacao={guiaInternacao} key={guiaInternacao?.id} />}
    pdfToPrint={pdfToPrint}
    onAfterPrint={onAfterPrint}
  />
)
